<template>
  <div class="mb-2 waste-stream-option parent-waste-stream">
    <!-- Input -->
    <div
      class="paragraph-reduced d-flex align-items-center flex-wrap"
      :class="{ 'justify-content-start': childWasteWithSpinner }"
    >
      <div class="flex-row" :class="{'waste-stream-wrapper' : childWasteWithSpinner}">
        <div v-if="this.data.special_waste_stream_enable">
          <!-- Custom Info -->
          <div class="d-flex align-items-center flex-wrap">
            <div class="wastestream-question" v-html="data.special_waste_stream_question || 'Please select option below?'"></div>
            <!-- Additional Info Header -->
            <div
              v-if="hasAdditionalInfo && this.data.special_waste_stream_enable"
              class="d-block d-sm-inline-block text-warning text-underlined pl-lg-2 ml-4 special_waste_stream_enable"
            >
              <u
                class="text-tru-orange cursor-pointer paragraph-reduced text-link-blue"
                :id="'additional-info-' + optionId"
                tabindex="0"
                v-on:keypress="
                  (event) => {
                    simulateClick(event, 'additional-info-' + optionId);
                  }
                "
                v-html="additionalInfoHeader || '<p>Preparing for collection</p>'"
                @click="toggleAdditionalInfo"
              ></u>
            </div>
          </div>
          <div class="form-check">
            <input :id="`wasteStreamToggle${optionId}Yes`"
              class="form-check-input"
              type="radio"
              :name="`wasteStreamToggle${optionId}`"
              :value="optionId"
              :checked="localSpecialOption === 'yes'"
              @input="handleSpecialOption" />
              <label class="form-check-label" :for="`wasteStreamToggle${optionId}Yes`">
                {{this.data.special_waste_stream_yes_response || 'Yes'}}
              </label>
          </div>
          <div class="form-check">
            <input :id="`wasteStreamToggle${optionId}No`"
              class="form-check-input"
              type="radio"
              :name="`wasteStreamToggle${optionId}`"
              value=""
              :checked="localSpecialOption === 'no'"
              @input="handleSpecialOption" />
              <label class="form-check-label" :for="`wasteStreamToggle${optionId}No`">
                {{this.data.special_waste_stream_no_response || 'Yes'}}
              </label>
            </div>
        </div>
        <input
          v-show="!this.data.special_waste_stream_enable"
          v-if="!this.hasParentWasteStream || !this.isMultipleSelection"
          :id="`wasteStreamToggle${optionId}`"
          :type="!isMultipleSelection ? `radio` : `checkbox`"
          :value="optionId"
          @input="handleInput"
          v-model="inputModel"
          :name="
            !hasParentWasteStream
              ? `wasteStreamToggle`
              : `variationToggle${parentOptionId}`
          "
          class="form-check-input"
          @change="handleInputChanged"
        />
        <!-- Waste Stream Name -->
        <label
          v-show="!this.data.special_waste_stream_enable"
          class="form-check-label"
          :for="`wasteStreamToggle${optionId}`"
          tabindex="0"
          @keydown="
            (event) => {
              simulateClick(event, `wasteStreamToggle${optionId}`);
            }
          "
          v-html="productNames.displayName"
        />
        <!-- Price -->
        <span v-if="isPaid && !hasVariations && displayPrice" class="ml-1">
          -
          <span class="d-inline-block font-weight-bold ml-1 skiptranslate">
            {{ `$${displayPrice.toFixed(2)}` }}
          </span>
        </span>
      </div>
      <!-- Toggle Input -->

      <!-- Spinner -->
      <div
        v-if="displaySpinner && !hasVariations"
        class="b-form-spinbutton form-control ms-2 centerizebtn skiptranslate d-inline-flex align-items-stretch form-control-sm"
        :class="{ disabled: !isToggled }"
      >
        <!-- Decrement button -->
        <button
            class="btn btn-sm border-0 rounded-0 py-0"
            type="button"
            :disabled="!isToggled"
            @click="decrement"
        >
            <span class="text--gray text-bold">-</span>
        </button>

        <!-- Number -->
        <output
          class="flex-grow-1 align-self-center border-left border-right"
          :name="'spinner' + optionId"
        >
          <bdi>{{ spinnerModel }}</bdi>
        </output>

        <!-- Increment button -->
        <button
            class="btn btn-sm border-0 rounded-0 py-0"
            type="button"
            :disabled="!isToggled"
            @click="increment"
        >
            <span class="text--gray text-bold">+</span>
        </button>
        </div>

      <!-- UOM -->
      <span
        v-if="!parentWasteStreamId && displaySpinner && !hasVariations"
        class="ml-1"
      >
        <span class="d-inline-block ml-1">
          {{ displayUom }}
        </span>
      </span>

      <!-- Additional Info Header -->
      <div
        v-if="hasAdditionalInfo && !this.data.special_waste_stream_enable"
        class="d-block d-sm-inline-block text-warning text-underlined pl-lg-2 ml-4 special_waste_stream_NOT_enable"
      >
        <u
          class="text-tru-orange cursor-pointer paragraph-reduced text-link-blue"
          :id="'additional-info-' + optionId"
          tabindex="0"
          v-on:keypress="
            (event) => {
              simulateClick(event, 'additional-info-' + optionId);
            }
          "
          v-html="additionalInfoHeader || '<p>Preparing for collection</p>'"
          @click="toggleAdditionalInfo"
        ></u>
      </div>
    </div>

    <!-- Additional Info Text -->
    <div class="row pt-3 pb-3" v-if="displayAdditionalInfo">
      <div class="col-lg-12">
        <div
          class="bundle-greenwaste-note border rounded d-block p-3"
          v-html="additionaInfoText"
        />
      </div>
    </div>

    <!-- Recursion -->
    <div
      v-if="hasVariations && isToggled"
      class="pl-4 waste-stream-option--child"
    >
      <WasteStreamOption
        class="pl-2"
        v-for="variation in variations"
        :key="`${
          variation.waste_stream_setting_id || variation.woi_waste_type_id
        }-${variation.waste_variation_id || variation.woi_waste_type_id}`"
        :data="variation"
        :isPaid="isPaid"
        :isMultipleSelection="isMultipleVariationSelection"
        :isMultipleCollection="isMultipleCollection"
        :multipleCollectionCount="multipleCollectionCount"
        :isDisplayMaxQuantity="isDisplayMaxQuantity"
        :isParentToggled="isToggled"
        :parentWasteStreamId="wasteStreamId"
        :parentOptionId="optionId"
        :parentWasteStreamName="productNames.displayName"
        :parentApiValue="data.api_value"
        @update="(wasteStreamSelection) => relayUpdate(wasteStreamSelection)"
        :removeProduct="removeProduct"
        @notifyParentWasteStreamReevaluateChild="
          notifyParentWasteStreamReevaluateChild
        "
      />
    </div>
  </div>
</template>

<script>
import TEXTS from "../../../../common/utils/Texts";
import BookingDatesMixin from "../../../../common/mixins/BookingDatesMixin";
export default {
  mixins: [BookingDatesMixin],
  name: `WasteStreamOption`,
  props: {
    data: Object,
    isPaid: Boolean,
    isMultipleSelection: Boolean,
    isMultipleCollection: Boolean,
    multipleCollectionCount: Number,
    isDisplayMaxQuantity: Boolean,
    isParentToggled: Boolean,
    parentWasteStreamId: Number,
    parentOptionId: String,
    parentWasteStreamName: String,
    parentApiValue: String,
    removeProduct: Array,
    selectedBookingProducts: Array,
    isFake: Boolean
  },
  data() {
    return {
      inputModel: false,
      spinnerModel: 0,
      qty: 0,
      isToggled: false,
      displayAdditionalInfo: false,
      maximumQuantity: null,
      maximumQuantityLabel: null,
      localSpecialOption: ''
    };
  },
  computed: {
    selectedSpecialOptions() {
      return (
        this.$store.getters.GET_BOOKING_STATE.selectedSpecialOptions || {}
      );
    },
    specialOptionValue() {
      return this.selectedSpecialOptions[this.wasteStreamId] || {};
    },
    isSpecialOptionYes() {
      return this.specialOptionValue.option === 'yes';
    },
    isSpecialOptionNo() {
      return this.specialOptionValue.option === 'no';
    },
    childWasteWithSpinner() {
      return (
        this.parentWasteStreamId && this.displaySpinner && !this.hasVariations
      );
    },
    wasteStreamId() {
      var wasteStreamId = this.data ? this.data.waste_stream_setting_id : null;
      if (!wasteStreamId && this.parentWasteStreamId) {
        wasteStreamId = this.parentWasteStreamId;
      }
      return wasteStreamId;
    },
    hasParentWasteStream() {
      return (
        this.parentWasteStreamId != null &&
        this.parentWasteStreamId != undefined
      );
    },
    varationId() {
      return this.data ? this.data.waste_variation_id : null;
    },
    woiWasteTypeId() {
      return this.data ? this.data.woi_waste_type_id : null;
    },
    woiWasteItemTypeId() {
      return this.data ? this.data.woi_waste_item_type_id : null;
    },
    optionId() {
      var optionId = `waste${this.wasteStreamId}`;
      if (this.varationId) {
        optionId += `-${this.varationId}`;
      } else if (this.woiWasteTypeId) {
        optionId += `-${this.woiWasteTypeId}`;
      } else if (this.woiWasteItemTypeId) {
        optionId += `-${this.woiWasteItemTypeId}`;
      }
      return optionId;
    },
    productNames() {
      var names = {};

      if (!this.data) {
        names = null;
      }
      // --- Determine Display Name
      else if (!this.parentWasteStreamName) {
        // --- Level 1 Waste Stream
        names.displayName = this.data.waste_stream_name;
        names.wasteStreamName = this.data.waste_stream_name;
      } else {
        // --- Level 2 Waste Stream
        names.parentWasteStreamName = this.parentWasteStreamName;
        names.wasteStreamName = this.parentWasteStreamName;
        names.variationName = this.data.variation_name;
        names.woiWasteName = this.data.woi_waste_name;

        // --- Determine Display Name
        names.displayName = names.variationName || names.woiWasteName;
      }

      return names;
    },
    displayPrice() {
      var price;

      var priceSettings = this.data ? this.data.price_settings : 0;

      if (!priceSettings) {
        price = 0;
      } else {
        if (
          priceSettings.enddate &&
          new Date() > new Date(priceSettings.enddate)
        ) {
          price = priceSettings.price2;
        } else {
          price = priceSettings.price1 || priceSettings.price2 || 0;
        }
      }

      if (typeof price == "string") {
        price = parseFloat(price);
      }

      // --- Return a price only if it's > 0
      if (price > 0) {
        return price;
      }
    },
    displayUom() {
      if (this.data.uom) {
        return this.data.uom;
      } else if (this.data.api_uom) {
        return this.data.api_uom;
      }
    },
    displaySize() {
      if (this.data.size) {
        return this.data.size;
      } else if (this.data.api_size) {
        return this.data.api_size;
      }
    },
    displaySpinner: function () {
      if (this.isFake) {
        return false;
      }
      if (this.hasParentWasteStream) {
        return this.isMultipleSelection;
      } else {
        return this.$store.getters.GET_BOOKING_STATE.displayStreamQuantities;
      }
    },
    // --- Additional Info
    hasAdditionalInfo() {
      return (
        this.data &&
        this.data.additional_info_header &&
        this.data.additional_info_text
      );
    },
    additionalInfoHeader() {
      return this.data ? this.data.additional_info_header : null;
    },
    additionaInfoText() {
      return this.data ? this.data.additional_info_text : null;
    },
    apiValue() {
      if (this.parentApiValue) {
        return this.parentApiValue;
      } else {
        return this.data.api_value;
      }
    },
    autoSelect() {
      return !!this.data.auto_select || false;
    },
    preselected() {
      return !!this.data.preselected_fixed || false;
    },
    // --- Variations
    hasVariations() {
      return this.data && this.data.has_variation == 1;
    },
    variations() {
      return this.data ? this.data.children : null;
    },
    isMultipleVariationSelection() {
      return this.data ? this.data.variation_selection == 2 : null;
    },
    determineServiceWastes() {
      return this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_PRODUCTS.filter(
        (product) =>
          product.service_group_id ===
            this.$store.getters.GET_ACTIVE_SERVICE_GROUP.service_group_id &&
          product.service_setting_id ===
            this.$store.getters.GET_ACTIVE_SERVICE_SETTING.service_setting_id
      );
    },
    determineWasteStreamPreselection() {
      return this.determineServiceWastes.filter(
        (product) => product.waste_stream_setting_id === this.wasteStreamId
      );
    },
    determineVariationPreselection() {
      if (!this.varationId || !this.determineWasteStreamPreselection)
        return false;
      return this.determineWasteStreamPreselection.find(
        (product) => product.waste_variation_id === this.varationId
      );
    },
    determineWoiWasteTypePreselection() {
      if (!this.woiWasteTypeId || !this.determineWasteStreamPreselection)
        return false;
      return this.determineWasteStreamPreselection.filter(
        (product) => product.woi_waste_type_id === this.woiWasteTypeId
      );
    },
    determineWoiWasteItemTypePreselection() {
      if (!this.woiWasteItemTypeId || !this.determineWoiWasteTypePreselection)
        return false;
      return this.determineWoiWasteTypePreselection.find(
        (product) => product.woi_item_type_id === this.woiWasteItemTypeId
      );
    },
    dataActiveMultipleServiceSelectedBookingProducts() {
      const isParent = this.hasVariations && this.isToggled;
      const isInputModelType = !this.isMultipleSelection ? `radio` : `checkbox`;
      const isParentInputModelType = !isParent ? (!this.$parent.isMultipleSelection ? `radio` : `checkbox`) : null;
      return {
        data: {
          waste_stream_setting_id: this.wasteStreamId,
          waste_variation_id: this.varationId || undefined,
          woi_waste_type_id: this.woiWasteTypeId || undefined,
          woi_item_type_id: this.woiWasteItemTypeId || undefined,
          qty: this.displaySpinner && !this.hasVariations ? 0 : 1,
          price:
            this.isPaid && !this.hasVariations && this.displayPrice
              ? this.displayPrice
              : 0,
          name: this.productNames,
          isPaid: this.isPaid,
          option_id: this.optionId, // --- For comparison
          parent_option_id: this.parentOptionId, // --- For comparison
          max_per_collection: this.data.max_per_collection,
          uom: this.data.uom,
          apiValue: this.apiValue,
          wasteComboApiValue: this.data.wastestream_combo_api_value,
          isMultipleSelection: this.isMultipleSelection,
          dependencyStreamId: this.data.dependencyStreamId,
          dependency_waste_stream_setting_id: this.data.dependency_waste_stream_setting_id,
          special_waste_stream_enable: this.data.special_waste_stream_enable,
          special_waste_stream_question: this.data.special_waste_stream_question,
          special_waste_stream_yes_response: this.data.special_waste_stream_yes_response,
          special_waste_stream_no_response: this.data.special_waste_stream_no_response,
          special_waste_stream_required_message: this.data.special_waste_stream_required_message,
        },
        adding: null,
        isInputModel: !this.hasParentWasteStream || !this.isMultipleSelection,
        isInputModelType,
        isSpinnerModel: this.displaySpinner && !this.hasVariations,
        isParent,
        isParentInputModelType
      };
    },
    wasteStreamMultiplier() {
      /*
        DEF_056_S15:Multi Coll-Waste multiplier
        Date: 2021-02-03
        Auth: Franco Mapua
        Desc: Modifying the step of the step button on change
      */
      return this.data.multiplier || 1;
    },
    selectedServiceWording() {
      var bookingState = this.$store.getters.GET_BOOKING_STATE;
      if (bookingState && bookingState.selectedService) {
        return bookingState.selectedService.wording;
      }

      return null
    },
  },
  mounted() {
    var thisInstance = this;
    // --- Establish Maximum Quantity
    this.calculateMaximumQuantity();

    // --- Automatic Toggling for children waste streams
    if (this.hasParentWasteStream && this.isMultipleSelection) {
      this.isToggled = this.isParentToggled;
    }

    // --- Check if already in MultipleServiceCart if fake stream
    if (
      this.isFake &&
      this.$store.getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED &&
      this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_PRODUCTS.length > 0
    ) {
      this.inputModel = this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_SELECTED_BOOKING_PRODUCTS.some(
        (bookingProduct) => bookingProduct.option_id == this.optionId
      );
    }

    // --- Triggered when another service is selected
    this.$parent.$on("loadWasteStreamState", thisInstance.loadWasteStreamState);

    // --- Triggers whenever another waste stream is selected elswhere
    this.$parent.$on("inputChange", this.handleParentInputChange);

    // --- Triggers for change instruction from parent
    this.$parent.$on(
      "broadcastChangeInstructions",
      this.receiveChangeInstruction
    );

    this.$parent.$on(
      "broadcastChangeInstructionToChildren",
      this.receiveChangeInstruction
    );

    if (this.woiWasteTypeId) {
      if (this.determineWoiWasteTypePreselection.length > 0) {
        if (!this.hasParentWasteStream || !this.isMultipleSelection) {
          this.inputModel = this.isMultipleSelection
            ? true
            : `${this.determineWoiWasteTypePreselection[0].waste_stream_setting_id}-${this.determineWoiWasteTypePreselection[0].woi_waste_type_id}`;
          this.updateWasteStreamState(this.inputModel);
        } else if (this.displaySpinner && !this.hasVariations) {
          this.spinnerModel = this.determineWoiWasteTypePreselection[0].qty;
        }
      }
    } else if (this.varationId) {
      if (this.determineVariationPreselection) {
        if (!this.hasParentWasteStream || !this.isMultipleSelection) {
          this.inputModel = this.isMultipleSelection
            ? true
            : `${this.determineVariationPreselection.waste_stream_setting_id}-${this.determineVariationPreselection.waste_variation_id}`;
          this.updateWasteStreamState(this.inputModel);
        } else if (this.displaySpinner && !this.hasVariations) {
          this.spinnerModel = this.determineVariationPreselection.qty;
        }
      }
    } else if (this.wasteStreamId) {
      if (this.determineWasteStreamPreselection.length > 0) {
        this.inputModel = this.isMultipleSelection
          ? true
          : this.determineWasteStreamPreselection[0].waste_stream_setting_id;
        if (this.inputModel) {
          if (this.hasVariations) {
            this.isToggled = true;
          } else {
            if (!this.hasParentWasteStream && this.displaySpinner) {
              this.isToggled = true;
              this.spinnerModel = this.determineWasteStreamPreselection[0].qty;
            } else {
              this.updateWasteStreamState(this.inputModel);
            }
          }
        }
      }
    }

    if(
      this.autoSelect || this.preselected
    ) {
      document.getElementById(`wasteStreamToggle${this.optionId}`).click();
      if (this.preselected) {
        // Disable input field
        document.getElementById(`wasteStreamToggle${this.optionId}`).disabled = true;
      }
    }
    if (this.data.special_waste_stream_enable) {
      const selectedSpecialOptions = this.$store.getters.GET_BOOKING_STATE.selectedSpecialOptions || {};
      const specialOption = selectedSpecialOptions[this.wasteStreamId];
      if (this.inputModel === false) {
        this.localSpecialOption = (specialOption && specialOption.option) ? 'no' : '';
      } else {
        this.localSpecialOption = 'yes';
      }
    }
  },
  watch: {
    specialOptionValue: {
      immediate: true,
      handler(value) {
        this.localSpecialOption = value;
      }
    },
    multipleCollectionCount() {
      this.calculateMaximumQuantity();
    },
    removeProduct: function (prods) {
      if (
        prods.length &&
        !this.dataActiveMultipleServiceSelectedBookingProducts.isParent
      ) {
        const currProductDetails = this
          .dataActiveMultipleServiceSelectedBookingProducts;
        let self = this;
        prods.forEach((prod) => {
          if (
            currProductDetails.data.waste_stream_setting_id ===
              prod.waste_stream_setting_id &&
            currProductDetails.data.waste_variation_id ===
              prod.waste_variation_id &&
            currProductDetails.data.woi_waste_type_id ===
              prod.woi_waste_type_id &&
            currProductDetails.data.woi_item_type_id === prod.woi_item_type_id
          ) {
            self.removeProductFromSelected(currProductDetails, self);

            // I'll notify my parent waste stream that it's children might have been cleared
            self.$emit("notifyParentWasteStreamReevaluateChild");
          }
        });
      }
    },
    spinnerModel() {
      this.onSpinnerInput();
      this.onSpinnerInputChanged();
    }
  },
  methods: {
    notifyParentWasteStreamReevaluateChild() {
      // If me as parent waste stream has no children selected for booking will now reset myself
      if (!this.determineWasteStreamPreselection.length) {
        this.removeProductFromSelected(
          this.dataActiveMultipleServiceSelectedBookingProducts,
          this
        );
      }
    },
    removeProductFromSelected(currProductDetails, self) {
      if (currProductDetails.isInputModel) {
        if (currProductDetails.isInputModelType === `checkbox`) {
          $("#" + `wasteStreamToggle${self.optionId}`).click();
          return;
        } else {
          self.removeChildrenRadioSelection();
          return;
        }
      }
      if (currProductDetails.isSpinnerModel) {
        self.spinnerModel = 0;
        self.onSpinnerInput();
        self.onSpinnerInputChanged();
      }
    },
    handleSpecialOption(event) {
      const value = event.target.value;
      if (value === String(this.optionId)) {
        // Yes selected
        this.inputModel = true;
        document.getElementById(`wasteStreamToggle${this.optionId}`).checked = true;
      } else {
        // No selected
        this.inputModel = '';
        document.getElementById(`wasteStreamToggle${this.optionId}`).checked = false;
      }
      if(this.handleInput()) {
        this.handleInputChanged();
      } else {
        this.inputModel = '';
        document.getElementById(`wasteStreamToggle${this.optionId}`).checked = false;
        this.setSpecialOption(this.wasteStreamId, '');
      }
    },

    setSpecialOption(wasteStreamId, inputModel) {
      const option = inputModel === '' || inputModel === false ? 'no' : 'yes';
      const selectedSpecialOptions =
        this.$store.getters.GET_BOOKING_STATE.selectedSpecialOptions || {};

      this.localSpecialOption = option;
      if (selectedSpecialOptions[wasteStreamId] && selectedSpecialOptions[wasteStreamId].option === option) {
        return;
      }

      this.$store.dispatch('setBookingState', {
        selectedSpecialOptions: {
          ...selectedSpecialOptions,
          [wasteStreamId]: {option, ...this.data}
        }
      });
    },
    handleInputChanged() {
      /*
        Stry: [UAT-5] Default value for waste stream spinner
        Date: 2021-02-22
        Auth: Franco Mapua
        Desc: Auto moving spinner on selection
      */
      var toggled = this.checkToggle();
      this.isToggled = toggled;

      if (this.inputModel && this.displaySpinner && !this.hasVariations) {
        this.spinnerModel = this.wasteStreamMultiplier;
        this.onSpinnerInputChanged();
      }

      if (!this.inputModel || !this.isToggled) {
        this.updateWasteStreamState(0);
      }
      if (this.data.special_waste_stream_enable && (this.checkRadioYes() || this.checkRadioNo())) {
        this.setSpecialOption(
          this.wasteStreamId,
          this.inputModel
        );
      }

      this.$store.dispatch("setActiveMultipleServiceSelectedBookingProducts", {
        ...this.dataActiveMultipleServiceSelectedBookingProducts,
        ...{
          adding: !!this.inputModel,
        },
      });
    },
    handleParentInputChange() {
      var toggled = this.checkToggle();
      this.isToggled = toggled;

      // --- Clear State for Radio Buttons
      if (!this.isMultipleSelection && this.hasVariations && !this.isToggled) {
        this.clearStreamState();
      }

      if (!this.isToggled && this.spinnerModel != 0) {
        this.spinnerModel = 0;
        this.updateWasteStreamState(0);
      }
      // --- Case for single selection waste streams that aren't toggled
      else if (!this.isToggled && this.isMultipleSelection == false) {
        // this.updateWasteStreamState(0);
      }
    },
    increment() {
      if (!this.isToggled) return
      const next = this.spinnerModel + this.wasteStreamMultiplier
      this.spinnerModel = Math.min(next, this.maximumQuantity || Infinity)
    },
    decrement() {
      if (!this.isToggled) return
      const next = this.spinnerModel - this.wasteStreamMultiplier
      this.spinnerModel = Math.max(next, 0)
    },
    onSpinnerInputChanged() {
      this.$store.dispatch("setActiveMultipleServiceSelectedBookingProducts", {
        ...this.dataActiveMultipleServiceSelectedBookingProducts,
        ...{
          data: {
            ...this.dataActiveMultipleServiceSelectedBookingProducts.data,
            qty: this.spinnerModel,
          },
          adding: !!this.spinnerModel,
        },
      });
    },
    calculateMaximumQuantity() {
      var maximumQuantity = this.data ? this.data.max_per_collection : 0;
      var isMaximumQuantityDefaulted = this.data
        ? this.data.max_per_collection_defaulted
        : false;

      if (
        this.multipleCollectionCount &&
        !isNaN(maximumQuantity) &&
        !isNaN(this.multipleCollectionCount)
      ) {
        maximumQuantity = maximumQuantity * this.multipleCollectionCount;
      }

      // --- Set the label for the DOM
      if (maximumQuantity && !isMaximumQuantityDefaulted) {
        var renderObj = {
          maximumQuantity,
          unitofmeasurement: this.data.uom || "",
        };
        this.maximumQuantityLabel = TEXTS.render(
          `WASTE_STREAM_OPTION_MAXIMUM_QUANTITY_LABEL`,
          null,
          renderObj
        );
      }

      this.maximumQuantity = maximumQuantity;
    },
    handleInput() {
      /*
        Stry: [UAT-5] Default value for waste stream spinner
        Date: 2021-02-22
        Auth: Franco Mapua
        Desc: Auto moving spinner on selection
      */
      // --- If changed to false
      var inputIsChecked = this.checkToggle();
      this.isToggled = inputIsChecked;

      // --- Cancel out selection and display error
      if (inputIsChecked == true || this.checkRadioYes() == true) {
        var bookingDates = this.getBookingDatesOfWasteStream({
          wasteStreamApi: this.data.api_value,
          parentStreamApi: this.parentApiValue,
        });

        if (
          Array.isArray(bookingDates) &&
          bookingDates.length == 0 &&
          !this.isFake
        ) {
          this.$emit(
            "showAlert",
            (
              this.selectedServiceWording &&
              this.selectedServiceWording.no_avaiable_dates &&
              this.selectedServiceWording.no_avaiable_dates != ""
            )
              ? this.selectedServiceWording.no_avaiable_dates
              : TEXTS.render("WASTE_STREAM_OPTION_NO_BOOKING_DATES")
          );

          document.getElementById(
            `wasteStreamToggle${this.optionId}`
          ).checked = false;

          // in case error, set to No
          document.getElementById(`wasteStreamToggle${this.optionId}No`).checked = true;
          document.getElementById(`wasteStreamToggle${this.optionId}Yes`).checked = false;

          this.$emit("invalidWaste");

          return false;
        }
      }

      // --- If option does not have variations, and no spinner, add 1 to the cart
      if (!this.hasVariations && !this.displaySpinner) {
        this.updateWasteStreamState(inputIsChecked ? 1 : 0);
      }

      // --- If disabled and has variations, disable them all
      if (!inputIsChecked && this.hasVariations) {
        this.clearStreamState();
      }

      // --- If Enabled and has variations, send a flag to disable the calendar if no variations are selected as well
      if (inputIsChecked && this.hasVariations) {
        this.updateWasteStreamState(-1); // Using -1 as a qty that will be overwritten by this stream's variations when they're selected
      }

      // --- If Enabled and has variations, send a flag to disable the calendar if no variations are selected as well
      if (inputIsChecked && this.displaySpinner && this.spinnerModel < 1) {
        this.updateWasteStreamState(-1);
      }
      // --- Emit an event upwards so the parent knows something changed
      this.$parent.$emit("inputChange");
      return true;
    },
    checkToggle() {
      var input = document.getElementById(`wasteStreamToggle${this.optionId}`);
      return (input ? input.checked : false);
    },
    checkRadioYes() {
      const input = document.getElementById(
        `wasteStreamToggle${this.optionId}Yes`
      );
      return input ? input.checked : false;
    },
    checkRadioNo() {
      const input = document.getElementById(
        `wasteStreamToggle${this.optionId}No`
      );
      return input ? input.checked : false;
    },
    checkRadioToggle() {
      return this.checkRadioYes() || this.checkRadioNo();
    },
    onSpinnerInput() {
      this.updateWasteStreamState(this.spinnerModel);
    },
    toggleAdditionalInfo() {
      this.displayAdditionalInfo = !this.displayAdditionalInfo;
    },
    updateWasteStreamState(qty) {
      var payload = {};
      var productNames = this.productNames;
      payload[this.optionId] = {
        qty,
        productNames,
        waste_stream_setting_id: this.wasteStreamId,
        waste_variation_id: this.varationId,
        woi_waste_type_id: this.woiWasteTypeId,
        waste_woi_waste_type_id: this.woiWasteTypeId, // --- For Legacy Compatibility
        woi_item_type_id: this.woiWasteItemTypeId,
        waste_woi_item_type_id: this.woiWasteItemTypeId, // --- For Legacy Compatibility
        option_id: this.optionId, // --- For comparison
        parent_option_id: this.parentOptionId, // --- For comparison
        parent_name: this.parentWasteStreamName,
        max_per_collection: this.data.max_per_collection,
        hasVariation: this.data.has_variation,
        price: this.displayPrice || 0,
        uom: this.data.uom,
        apiValue: this.apiValue,
        wasteComboApiValue: this.data.wastestream_combo_api_value,
        isMultipleSelection: this.isMultipleSelection,
        siteForMultiCollection: this.data.site_for_multi_collection,
        isSubmitWith: this.data.submit_with != null,
        isFake: this.isFake,
        dependencyStreamId: this.data.dependencyStreamId,
        dependency_waste_stream_setting_id: this.data.dependency_waste_stream_setting_id,
        special_waste_stream_enable: this.data.special_waste_stream_enable,
        special_waste_stream_question: this.data.special_waste_stream_question,
        special_waste_stream_yes_response: this.data.special_waste_stream_yes_response,
        special_waste_stream_no_response: this.data.special_waste_stream_no_response,
        special_waste_stream_required_message: this.data.special_waste_stream_required_message,
      };

      var selectedBookingProducts =
        this.$store.getters.GET_BOOKING_STATE &&
        this.$store.getters.GET_BOOKING_STATE.selectedBookingProducts
          ? this.$store.getters.GET_BOOKING_STATE.selectedBookingProducts
          : [];

      // --- If this option is a variation
      if (this.hasParentWasteStream) {
        var parentQty = null;
        var otherChildrenOfParent = selectedBookingProducts.filter(
          (product) => {
            var hasSameWasteStreamId =
              product.waste_stream_setting_id == this.wasteStreamId;
            var optionIdNotSame = product.option_id != this.optionId;
            return hasSameWasteStreamId && optionIdNotSame && product.qty > 0;
          }
        );

        // --- Reset the -1 flag that the parent has set on itself to disable itself
        if (qty > 0) {
          parentQty = 0;

          // --- Remove other variations that belong to the same parent
          if(!this.isMultipleSelection){
            otherChildrenOfParent.forEach((product) => {
              payload[product.option_id] = { qty: 0 };
            });
          }
        }
        // --- Scan the BookingState.selectedBookingProducts for Waste Variations of the same Parent that have non-zero qty's
        else {
          if (otherChildrenOfParent.length > 0) {
            /**
            * Stry: RP-109
            * Date: 2021-04-19
            * Auth: Joseph Ricohermoso
            * Desc: Check if current evaluation has parent waste.
            *       If current evaluation is 2nd level with non-spinner input
            */
            if (this.parentOptionId && !(this.displaySpinner && !this.hasVariations) ) {
              parentQty = -1;
            }
          }
        }

        // --- Set the parent Quantity
        if (parentQty != null) {
          payload[this.parentOptionId] = { qty: parentQty };
        }

        // Fixed 2021-01-29 Joseph: DEF_052_"please select waste" not showing for missing waste variation/woi waste
        // Description: When deselecting waste variation/woi waste we expect to still mark the parent stream as selected in `selectedBookingProducts`
        // for the validation to kickin. This fix should support both single and multi service booking
        if (payload[this.parentWasteStreamId]) {
          payload[
            this.parentWasteStreamId
          ].waste_stream_setting_id = this.parentWasteStreamId;
          payload[
            this.parentWasteStreamId
          ].hasVariation = this.$parent.data.has_variation;
        }
      } else if (
        !this.hasParentWasteStream &&
        !this.isMultipleSelection &&
        qty > 0
      ) {
        var otherProducts = selectedBookingProducts.filter((product) => {
          return (
            product.waste_stream_setting_id != this.data.waste_stream_setting_id
          );
        });
        otherProducts.forEach((product) => {
          payload[product.option_id] = { qty: 0 };
        });
      }

      if (
        !this.hasVariation &&
        !this.hasParentWasteStream &&
        this.isMultipleSelection
      ) {
        if (this.inputModel && qty <= 0) {
          payload[this.optionId].multiSpinnerChecker = true;
          payload[this.optionId].qty = -1;
        } else {
          payload[this.optionId].multiSpinnerChecker = false;
        }
      }

      this.relayUpdate(payload);
    },
    relayUpdate(payload) {
      this.$emit("update", payload);
    },
    clearStreamState() {
      var payload = {
        [this.optionId]: { qty: 0 },
      };

      // --- For each varation, force a 0 value
      if (Array.isArray(this.variations)) {
        this.variations.forEach((variation) => {
          var optionId = `waste${
            variation.waste_stream_setting_id || this.wasteStreamId
          }`;
          if (variation.waste_variation_id) {
            optionId += `-${variation.waste_variation_id}`;
          } else if (variation.woi_waste_type_id) {
            optionId += `-${variation.woi_waste_type_id}`;
          } else if (variation.woi_waste_item_type_id) {
            optionId += `-${variation.woi_waste_item_type_id}`;
          }
          payload[optionId] = { qty: 0 };
        });
      }

      this.relayUpdate(payload);
    },
    loadWasteStreamState(streamState) {
      // --- Reset the state every time BUT change this for multiple service selectio
      streamState = null;

      if (!streamState)
        // --- Reset model
        this.spinnerModel = 0;
      this.inputModel = false;
      this.isToggled = false;

      // --- Recurse Downwards
      this.$emit("loadWasteStreamState", streamState);
    },
    simulateClick(event, target) {
      if (event.keyCode == 32 || event.keyCode == 13) {
        event.preventDefault();
        $("#" + target).click();
      }
    },
    removeChildrenRadioSelection() {
      this.handleInput();
      this.inputModel = false;
      this.isToggled = false;
      this.handleInputChanged();
    },
    receiveChangeInstruction(changeObject) {
      // --- Receive broadcasted instructions from parent and react if self is in instructions
      var changeInstruction = this.parentOptionId
        ? changeObject[this.parentOptionId]
        : changeObject[this.optionId];
      this.$emit("broadcastChangeInstructionToChildren", changeObject);

      if (changeInstruction != undefined && changeInstruction <= 0) {
        this.spinnerModel = 0;
        var toggleInput = document.getElementById(
          `wasteStreamToggle${this.optionId}`
        );
        if (toggleInput) toggleInput.checked = false;
        this.updateWasteStreamState(0);
        this.clearStreamState();
        this.$store.dispatch(
          "setActiveMultipleServiceSelectedBookingProducts",
          {
            ...this.dataActiveMultipleServiceSelectedBookingProducts,
            ...{
              data: {
                ...this.dataActiveMultipleServiceSelectedBookingProducts.data,
                qty: this.spinnerModel,
              },
              adding: !!this.spinnerModel,
            },
          }
        );
        var self = this;
        setTimeout(function () {
          self.isToggled = false;
        }, 200);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.centerizebtn button {
  min-height: 0px;
  color: red;
}
</style>